import 'jquery';
import 'popper.js/dist/popper';
import 'bootstrap';
import 'jquery-validation/dist/jquery.validate';
import 'jquery-validation/dist/additional-methods';
import 'jquery-validation-unobtrusive/dist/jquery.validate.unobtrusive';
import "smartmenus/dist/jquery.smartmenus";
import "smartmenus/dist/addons/bootstrap/jquery.smartmenus.bootstrap";
import Swiper, { Navigation, Pagination, Support } from 'swiper';
//import "snazzy-info-window/dist/snazzy-info-window";
//import "slick-carousel/slick/slick";
import "iframe-resizer";
import Player from '@vimeo/player';

// For loan calculator
import "updated-jqplot/dist/jquery.updated-jqplot.js";
import "updated-jqplot/dist/plugins/jqplot.pieRenderer.js";
import "updated-jqplot/dist/plugins/jqplot.highlighter.js";
import "updated-jqplot/dist/plugins/jqplot.cursor.js";
import "updated-jqplot/dist/plugins/jqplot.pointLabels.js";

// Custom Formulate Fields
import "/App_Plugins/FCBTFormulate/formulate-custom-fields.js";


// Install Service Worker
if ('serviceWorker' in navigator) {
    navigator.serviceWorker.register('/scripts/ctf-sw.js', { scope: '/scripts' }).then(function (reg) {

        //if (reg.installing) {
        //    console.log('Service worker installing');
        //} else if (reg.waiting) {
        //    console.log('Service worker installed');
        //} else if (reg.active) {
        //    console.log('Service worker active');
        //}

    }).catch(function (error) {
        // registration failed
        //console.log('Registration failed with ' + error);
    });
}

var loanCalc = require("./sitescripts/_fcbt-loan-calculator");
var CTF = CTF || {};

CTF.Site = {
    init: function () {
        loanCalc.loanCalculator();
        this.initializeAbolDropdown();
        this.initializeMenu('ul#main-menu', '#main-menu-state');
        this.initializePopoverClose();
        this.initializeScrollTop("div#ctf-site div.scrollTop");
        this.initializeVideoButtons();
        this.fitBackground();
    },
    initializeAbolDropdown: function () {
        $("#toggle-abol-dropdown").on("click", function (event) {
            var button = $(this);
            $("#abol-dropdown").appendTo(button.parent());
        })

        $("#toggle-abol-dropdown-mobile").on("click", function (event) {
            var button = $(this);
            $("#abol-dropdown").appendTo(button.parent());
        })

        // Close the dialog if user clicks anywhere else in the page.
        $(document).on("click", function (event) {
            if (
                !$("#abol-dropdown").is(event.target) &&
                !$("#toggle-abol-dropdown").is(event.target) &&
                !$("#toggle-abol-dropdown-mobile").is(event.target) &&
                !$(".abol-button-container").is(event.target) &&
                $("#abol-dropdown").has(event.target).length === 0
            ) {
                $("#abol-dropdown").collapse('hide');
            }
        })

        // Close the dialog if user resizes the window.
        window.addEventListener('resize', function () {
           // $("#abol-dropdown").collapse('hide');
        })

        // Disable the login button until something is entered into UserId field.
        var userInput = $("div#abol-dropdown input#user_id");
        var button = $("div#abol-dropdown button");
        if (userInput.val() === "") {
            button.prop("disabled", true);
        }
        userInput.on("keyup", function (event) {
            if ($(this).val() !== "") {
                button.prop("disabled", false);
            } else {
                button.prop("disabled", true);
            }
        })
    },
    initializeMenu: function (menuSelector, menuStateSelector) {
        var $menu = $(menuSelector);
        var $mainMenuState = $(menuStateSelector);

        $menu.smartmenus({
            mainMenuSubOffsetX: 14,
            mainMenuSubOffsetY: -7,
            markCurrentItem: true,
            markCurrentTree: true
        });

        if ($mainMenuState.length) {
            // animate mobile menu
            $mainMenuState.change(function (e) {

                if (this.checked) {
                    console.log("menuopen");
                    $menu.hide().slideDown(250, function () { $menu.css('display', ''); });
                } else {
                    $menu.show().slideUp(250, function () { $menu.css('display', ''); });
                }
            });
            // hide mobile menu beforeunload
            $(window).on('beforeunload unload', function () {
                if ($mainMenuState[0].checked) {
                    $mainMenuState[0].click();
                }
            });
        }
    },
    initializePopoverClose: function () {
        $(".close-popup-btn").on("click", function () {
            $(this).parent("div.close-btn-container").parent("div.popover").addClass("closed");
        })
    },
    initializeScrollTop: function (buttonSelector) {
        var scrollTop = $(buttonSelector);


        $(window).scroll(function () {
            // declare variable
            var topPos = $(this).scrollTop();
            // if user scrolls down - show scroll to top button
            if (topPos > 100) {
                $(scrollTop).css("opacity", "1");
            } else {
                $(scrollTop).css("opacity", "0");
            }

        });

        $(scrollTop).click(function () {
            $('html, body').animate({
                scrollTop: 0
            }, 800);
            return false;
        });
        
    },
    initializeHomeHeroVideoButtons: function () {        
        var pauseButton = $("div.homeHero > div.video-buttons-container > img.pause-btn");
        var playButton = $("div.homeHero > div.video-buttons-container > img.play-btn");        
        var iframe = $("div.homeHero iframe");
        var player = new Player(iframe);

        pauseButton.on("click", function (event) {
            pauseButton.hide();
            player.pause();
            playButton.show();
        })
        playButton.on("click", function (event) {
            playButton.hide();
            player.play();
            pauseButton.show();
        })
        pauseButton.show();
    },
    initializeVideoButtons: function () {        
        $("div.video > div.play-button").on("click", function (event) {
            var iframe = $(this).siblings("iframe");
            var player = new Player(iframe);
            player.play();
            $(this).hide();            
        })
    },
    parseBoolean: function (string) {
        var bool;
        bool = (function () {
            switch (false) {
                case string.toLowerCase() !== 'true':
                    return true;
                case string.toLowerCase() !== 'false':
                    return false;
            }
        })();
        if (typeof bool === "boolean") {
            return bool;
        }
        return void 0;
    },
    buildSwiper: function (swiperSelector, layout) {
        $('.swiper-button-prev').css('visibility', 'hidden');
        var breakpoints = {
            0: {
                slidesPerView: 1,
                spaceBetween: 36
            },
            768: {
                slidesPerView: 3,
                spaceBetween: 48
            },
            1200: {
                slidesPerView: 3,
                spaceBetween: 96
            },
            1300: {
                slidesPerView: 4,
                spaceBetween: 48
            },
            1600: {
                slidesPerView: 4,
                spaceBetween: 96
            },
            1750: {
                slidesPerView: 4,
                spaceBetween: 144
            },
            1900: {
                slidesPerView: 5,
                spaceBetween: 48
            },
            2100: {
                slidesPerView: 5,
                spaceBetween: 96
            },
            2200: {
                slidesPerView: 5,
                spaceBetween: 144
            },
            2400: {
                slidesPerView: 6,
                spaceBetween: 48
            },
            2600: {
                slidesPerView: 6,
                spaceBetween: 96
            },
            2750: {
                slidesPerView: 6,
                spaceBetween: 144
            }
        };
        Swiper.use([Navigation, Pagination]);
        var swiper = new Swiper(swiperSelector, {
            breakpoints: breakpoints,
            allowTouchMove: true,
            init: true,
            autoHeight: true,
            setWrapperSize: true,
            breakpointsInverse: false,
            normalizeSlideIndex: true,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            on: {
                sliderMove: function () {
                    $('.swiper-button-next').css('visibility', 'hidden');
                    $('.swiper-button-prev').css('visibility', 'hidden');
                },
                slideChangeTransitionStart: function () {
                },
                touchEnd: function () {
                    $('.swiper-button-next').css('visibility', 'visible');
                    $('.swiper-button-prev').css('visibility', 'visible');
                },
                reachEnd: function () {
                    $('.swiper-button-next').hide();
                },
                reachBeginning: function () {
                    $('.swiper-button-prev').hide();
                },
                fromEdge: function () {
                    $('.swiper-button-next').show();
                    $('.swiper-button-prev').show();
                }
            },
        });
    },
    fitBackground: function () {
        $(".content-with-background-image").each(function (index) {
            if ($(this).siblings(".background").children(".image-container").height() < $(this).height()) {
                $(this).parent().css("min-height", $(this).height() + 50);
                //$(this).siblings(".background").children(".image-container").css("opacity", "0");
            }
        });
    },
    pagerClick: function (linkName) {
        var paginationContainer = document.querySelector("ul.pagination");
        if (paginationContainer != null) {
            var navLinks = paginationContainer.querySelectorAll("li");
            if (navLinks != null && navLinks.length > 2) {
                var pageCount = navLinks.length - 2;
                var currentPage = 1;
                var targetPage = 1;
                for (var i = 0; i < navLinks.length; i++) {
                    if (navLinks[i].classList.contains('active')) {
                        currentPage = i;
                    }
                }

                if (linkName == "page-prev") {
                    if (currentPage > 1) {
                        targetPage = currentPage - 1;
                    }
                }
                else if (linkName == "page-next") {
                    if (currentPage < pageCount) {
                        targetPage = currentPage + 1;
                    }
                }
                else {
                    var parsedPage = parseInt(linkName.replace('page-', ''));
                    if (!isNaN(parsedPage)) {
                        targetPage = parsedPage;
                    }
                }
                this.hidePage(currentPage.toString());
                this.showPage(targetPage.toString());
                if (pageCount > 1) {
                    $('ul.pagination > li.page-prev').removeClass("disabled");
                    $('ul.pagination > li.page-next').removeClass("disabled");
                    if (targetPage == 1) {
                        $('ul.pagination > li.page-prev').addClass("disabled");
                    }
                    else if (targetPage == pageCount) {
                        $('ul.pagination > li.page-next').addClass("disabled");
                    }
                }
            }
        }
    },
    showPage: function (pageNumberString) {
        var navClass = 'ul.pagination > li.page-' + pageNumberString;
        var pageClass = 'div.pagination-wrapper > div.page-' + pageNumberString;
        $(navClass).addClass("active");
        $(pageClass).removeClass("d-md-none");
    },
    hidePage: function (pageNumberString) {
        var navClass = 'ul.pagination > li.page-' + pageNumberString;
        var pageClass = 'div.pagination-wrapper > div.page-' + pageNumberString;
        $(navClass).removeClass("active");
        $(pageClass).addClass("d-md-none");
    }
}

$(document).ready(function () {
    window.CTFWebSite = CTF.Site;
    window.CTFWebSite.init();
});


/*polyfill*/
/*Number.IsNan*/
if (!Number.isNaN) {
    Object.defineProperty(Number, 'isNaN', {
        value: function (value) {
            return value !== value;
        }
    });
}